import Vue from 'vue'

import Home from "../../views/home/Home";

import NotFound from "../../views/404/NotFound";

import TrendPage from "../../components/DynamicForms/Trends/TrendPage";

import { deliverModel, home } from "@/config";

import { isLedgerConfigMenu, getLedgerConfigRoutes, registerLedgerConfigComponents } from "@/extend/LedgerConfig/LedgerConfigMenuRegister";

const viewComponents = require.context('@/views', true, /\.vue$/).keys() // 视图组件数组

const importComponent = file => require(`@/views${file}.vue`).default // 根据文件路径引入文件

const viewComponentsMap = {} // 组件映射

const ignoreComponent = ['Home', 'NotFound']

viewComponents.forEach(address => {
    const ComponentPath = address.replace(/^\.(.*)\.vue$/,'$1')
    const ComponentName = ComponentPath.split('/').pop()
    viewComponentsMap[ComponentName] = importComponent(ComponentPath)
})

export const registerComponent = (menuMap, actionArr, activeMenu) => {
    const menuActionArray = [...Object.keys(menuMap), ...actionArr] // 用户菜单和所有权限的集合
    const path = window.__MICRO_APP_BASE_ROUTE__ || '/'
    if (deliverModel === 'router') {
        const children = []
        menuActionArray.forEach(componentName => {
            if (ignoreComponent.includes(componentName) || isLedgerConfigMenu(menuMap[componentName])) return // 过滤主页、404等通用路由，防止覆盖
            const component = viewComponentsMap[componentName] || { ...NotFound, name: componentName, data () { return { name: componentName } } }
            children.push({ path: `${componentName}`, name: componentName, component })
        })
        children.push(...getLedgerConfigRoutes(Vue.store.state.JMenu.menuList)) // 台账表单配置菜单注册
        Vue.router.addRoute({ path, name: 'Home', component: Home, children, redirect: `/${activeMenu}` })
    } else {
        Vue.router.addRoute({ path, name: 'Home', component: Home })
        menuActionArray.forEach(componentName => {
            if (ignoreComponent.includes(componentName) || isLedgerConfigMenu(menuMap[componentName])) return // 过滤主页、404等通用路由，防止覆盖
            const component = viewComponentsMap[componentName] || { ...NotFound, name: componentName || 'NotFound', data () { return { name: componentName } } }
            Vue.component(component.name, component)
        })
        registerLedgerConfigComponents(Vue.store.state.JMenu.menuList)
    }
}

export const getUserMenus = () => {
    // 获取用户可见菜单
    Vue.store.dispatch('JMenu/getMenuList', { deliverModel, home }).then(({ initActive, trendMenus }) => {
        // 追加动态台账
        trendMenus.forEach(menu => { viewComponentsMap[menu.address] = { ...TrendPage, name: menu.address, data () { return { ledgerId: menu.ledgerId } } } })
        // 获取用户可见行为
        Vue.store.dispatch('getRolesAction').then(() => {
            registerComponent(Vue.store.state.JMenu.menuMap, Vue.store.state.rolesAction, initActive)
            Vue.store.commit('JMenu/openMenu', initActive)
        })
    })
}

